__webpack_require__.p = "/dev/graphic-scores-test/";